import { Controller } from "react-hook-form";
import { InputTextarea } from "primereact/inputtextarea";
import { classNames } from "primereact/utils";
import { useState } from "react";
import { FloatLabel } from "primereact/floatlabel";

const TextareaInput = ({
  name,
  control,
  label,
  errors,
  isRequired,
  className,
  placeholder,
  onChange,
  rows,
  min,
  max,
  disabled,
}) => {
  const [charCount, setCharCount] = useState(0); // Estado para contar os caracteres

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: isRequired ? "Campo obrigatório" : false,
        minLength: {
          value: min || 0,
          message: `Digite pelo menos ${min} caracteres.`,
        },
        maxLength: {
          value: max || null,
          message: `Limite de ${max} caracteres.`,
        },
      }}
      render={({ field, fieldState }) => (
        <>
          <FloatLabel className={`w-100 ${className}`}>
            <InputTextarea
              id={field.name}
              value={field.value || ""}
              onChange={(e) => {
                const inputValue = e.target.value;
                if (!max || inputValue.length <= max) {
                  field.onChange(inputValue);
                  setCharCount(inputValue.length); // Atualiza o contador de caracteres
                }
                onChange && onChange(e); // Repasse do evento onChange se fornecido
              }}
              disabled={disabled}
              onBlur={() => field.onBlur()}
              placeholder={placeholder}
              required={isRequired}
              rows={rows || 4}
              cols={30}
              maxLength={max || null} // Aplica o maxLength se fornecido
              className={`w-100 ${classNames({
                "p-invalid": fieldState.error,
              })}`}
            />
            <label htmlFor={field.name}>{label}</label>
          </FloatLabel>
          {/* Mostra o contador de caracteres se max for definido */}
          {max && (
            <small className="char-counter">
              {charCount}/{max} caracteres
            </small>
          )}
          {/* Exibe mensagem de erro */}
          {fieldState.error && (
            <span className="p-error">{fieldState.error.message}</span>
          )}
        </>
      )}
    />
  );
};

export default TextareaInput;
